import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/internal/operators/take';
import { MatSnackBar } from '@angular/material/snack-bar';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SharedService } from '../../../../shared/services/shared.service';
import { environment } from '../../../../../environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { UtilsService } from '../../../../shared/services/utils.service';
import { EmailControllerService } from 'api-notification';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-landing-contact-us',
	standalone: true,
	imports: [CommonModule, MatCardModule, MatFormFieldModule, MatInputModule, TranslateModule, MatButtonModule, ReactiveFormsModule, MatProgressSpinnerModule],
	templateUrl: './landing-contact-us.component.html',
	styleUrl: './landing-contact-us.component.scss',
})
export class LandingContactUsComponent {
	resellerSettingsContext: any;
	mobileView = false;
	data: any = [];
	formGroup: FormGroup = new FormGroup({});

	apiLoading = {
		contactForm: false,
	};

	constructor(
		private fb: FormBuilder,
		private http: HttpClient,
		private _snackBar: MatSnackBar,
		private sharedService: SharedService,
		private responsive: BreakpointObserver,
		private utils: UtilsService,
		private apiNotification: EmailControllerService,
		private translate: TranslateService
	) {
		this.sharedService.resellerSettingsContext.pipe(takeUntilDestroyed()).subscribe({
			next: response => {
				this.resellerSettingsContext = response;
				this.resellerSettingsContext.reseller = environment.reseller;
				this.data = this.resellerSettingsContext.contact.data;
			},
		});

		this.formGroup = this.fb.group({
			emailFrom: [, [Validators.required, Validators.pattern(this.utils.VALIDATION_PATTERNS.get('E_MAIL') || '')]],
			phone: [],
			company: [],
			message: [, [Validators.required]],
			reseller: this.resellerSettingsContext.reseller.name.toUpperCase(),
		});

		this.responsive
			.observe([Breakpoints.XSmall, Breakpoints.Small])
			.pipe(takeUntilDestroyed())
			.subscribe(result => {
				this.mobileView = false;

				if (result.matches) {
					this.mobileView = true;
				}
			});
	}

	sendMessage(formDirective: FormGroupDirective) {
		this.apiLoading.contactForm = true;
		this.apiNotification
			.sendContactInfoDataToReseller(this.formGroup.value)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.ACTION_COMPLETE'),
						type: 'SUCCESS',
					});
					this.apiLoading.contactForm = false;
          this.formGroup.reset();
          if (formDirective) {
            formDirective.resetForm();
          }
          this.openSnackBar(this.translate.instant('NOTIFICATIONS.ACTION_COMPLETE'), 'OK');
				},
				error: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.ACTION_ERROR'),
						type: 'ERROR',
					});
					this.apiLoading.contactForm = false;
          this.openSnackBar(this.translate.instant('NOTIFICATIONS.ACTION_ERROR'), 'OK');
				},
			});
	}

	openSnackBar(message: string, action: string) {
		this._snackBar.open(message, action);
	}
}
